// Reads the `<script id="__ssg_initial_data__" type="application/json">…</script>`
// blob that `postbuild-seo.js` bakes into every detail-page shell. Returns
// the parsed object, or `null` when the tag is absent (dev/preview) or
// when its slug does not match the slug of the current route (guards
// against SPA client-side navigations picking up the *previous* URL's
// baked data).
//
// SEO-critical: without this hook the React app renders a bare spinner
// while the /by-slug XHR is in-flight, and JS-rendering Googlebot flags
// the page as Soft 404 (verified in Search Console — 283 valid chant /
// player / fan-club URLs were affected). Hydrating from the baked JSON
// gives crawlers a full DOM even when the XHR fails or is still pending.
export function readSsgInitialData(expectedSlug) {
  if (typeof document === "undefined") return null;
  const el = document.getElementById("__ssg_initial_data__");
  if (!el) return null;
  try {
    const parsed = JSON.parse(el.textContent || "{}");
    // Only trust the bake if its slug matches the current route slug.
    // Prevents a client-side SPA navigation from picking up the *previous*
    // page's baked data.
    if (expectedSlug && parsed.slug && parsed.slug !== expectedSlug) {
      return null;
    }
    return parsed;
  } catch (_e) {
    return null;
  }
}
